export default __webpack_public_path__ + "locales/uk-UA/JavascriptSdk.json?hash=e26f03b2501e3bccfad7b4c3ef738c7d";